import { makeAutoObservable, runInAction } from 'mobx';
import { clearPersistedStore, makePersistable } from 'mobx-persist-store';

class UserAccessStore {
  userAccessState = null;

  constructor(rootStore) {
    this.rootStore = rootStore;

    makeAutoObservable(this);

    makePersistable(this, {
      name: 'UserAccessStore',
      properties: ['userAccessState'],
    });
  }

  set(value) {
    runInAction(() => {
      this.userAccessState = value;
    });
  }

  isEmpty() {
    return this.userAccessState === null;
  }

  delete() {
    delete this.userAccessState;
  }

  get() {
    try {
      return this.userAccessState;
    } catch {
      return null;
    }
  }

  async clearStore() {
    await clearPersistedStore(this);
  }
}

export default UserAccessStore;
